












import Vue from 'vue'
import {Dictionary} from 'vuex'
import inReadyTableConfig from '@/activeTables/Newsletters/mailings-stuff'
import activeTable from '@/components/Ui/ActiveTable/ActiveTable.vue'
import store from '@/store'
import {MAILING_STATUS_READY} from '@/constants'

export default Vue.extend({
  name: 'newslettersInReadyList',
  components: {
    activeTable
  },
  data () {
    return {
      config: {},
      loaded: false,
      defaultFilters: {},
      defaultSort: {},
      MAILING_STATUS_READY,
      interval: null
    }
  },
  async beforeRouteEnter (to, from, next) {
    next();
  },
  methods: {
    mailingDataWatcher (): void {
      // @ts-ignore
      let self = this;
      // @ts-ignore
      self.interval = setInterval(() => {
        // @ts-ignore
        self.reloadMailing();
      }, 4000)
    },
    reloadMailing (): void {
      // @ts-ignore
      this.$refs.table.loadList()
    },
    clearInterval (): void {
      // @ts-ignore
      clearInterval(this.interval)
    }
  },
  async mounted () {
    this.config = inReadyTableConfig
    this.loaded = true
    this.mailingDataWatcher();
    this.$root.$on('relogin', this.clearInterval)
  },
  beforeDestroy () {
    // @ts-ignore
    clearInterval(this.interval)
    this.clearInterval()
    this.$root.$off('relogin', this.clearInterval)
  }
})
